import React from 'react'
import { Globe } from 'react-feather'

const Icon = ({name}) => {
  let image
  if(name === 'facebook') image = '/images/icons/khub_fb.jpg'
  else if(name === 'youtube') image = '/images/icons/khub_yt.jpg'
  else if(name === 'instagram' || name === 2 || name === '2') image = '/images/icons/khub_ig.jpg'
  else if(name === 'twitter' || name === 1 || name === '1') image = '/images/icons/khub_tw.jpg'
  else if(name === 'linkedin' || name === 4 || name === '4') image = '/images/icons/khub_li.jpg'

  const size = '28px'

  return name === 'website' ? (
    <Globe width={size} height={size}/>
  ) : (
    <div
      className={`bg-no-repeat bg-center bg-cover ${!image && 'bg-gray-500'}`}
      style={{backgroundImage: `url(${image})`, width: size, height: size}}
    />
  )
}

// const example = [
//   {
//     name: 'facebook',
//     link: 'https://facebook.com'
//   },
//   {
//     name: 'youtube',
//     link: 'https://youtube.com'
//   },
//   {
//     name: 'instagram',
//     link: 'https://instagram.com'
//   }
// ]

const SocialMedia = ({data = [], website, leftOnMobile = false}) => {
  return (
    <div className="">
      <h3 className={`${leftOnMobile ? '' : 'text-center'} lg:text-left font-bold lg:text-lg font-accent mb-4 lg:mb-5 uppercase`}>
        Social Media
      </h3>
      {
        (data && data.length > 0) ? (
          <div className={`flex flex-wrap ${leftOnMobile ? '' : 'justify-center'} lg:justify-start`}>
            {
              data.map((d, i) => (
                <div className="mr-2 mb-2" key={i}>
                  <a href={d.link} target="_blank" rel="noopener noreferrer" title={d.link}>
                    <Icon name={d.name ? d.name : undefined}/>
                  </a>
                </div>
              ))
            }
            {/* {
              website &&
              <div className="mr-2 mb-2">
                <a href={website} target="_blank" rel="noopener noreferrer" title={website}>
                  <Icon name={website ? 'website' : undefined} isGlobe/>
                </a>
              </div>
            } */}
          </div>
        ) : (
          <div>-</div>
        )
      }
    </div>
  )
}

export { SocialMedia }
